<template>
<div class="contentBox homePage">
    <div class="left">
        <div class="headerBoxTitle">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="headerTitle">账户余额</span>
                    <div class="btnBox" style="float: right">
                        <button v-if="!!sponsor.showRecharge" class="check" @click="jumpPage('/finance/my-order')">查看账单</button>
                        <button v-if="!!sponsor.showRecharge" class="buy" @click="jumpPage('/finance/recharge')">购买套餐</button>
                    </div>
                </div>
                <div class="balance">
                    <div class="item">
                        <span class="title">流量</span>
                        <div :class="flowClass">{{balance.formatFlow}}<span>{{balance.formatFlowUnit}}</span></div>
                    </div>
                    <div class="item middle">
                        <span class="title">空间</span>
                        <div :class="spaceClass">{{balance.formatSpace}}<span>{{balance.formatSpaceUnit}}</span></div>
                    </div>
                    <div class="item last">
                        <span class="title">时长</span>
                        <div :class="durationClass">{{balance.formatDuration}}</div>
                    </div>
                </div>
            </el-card>
        </div>

        <div class="entryBox">
            <div class="item" @click="jumpPage('/live/add')">
                <img src="../../assets/home-live-icon.svg" alt="" />
                <span>创建直播</span>
            </div>
            <div class="item" @click="jumpPage('/onDemand/add')">
                <img src="../../assets/upload-home-icon.svg" alt="" />
                <span>创建点播</span>
            </div>
            <div v-if="!!sponsor.showRecharge" class="item" @click="jumpPage('/finance/recharge')">
                <img src="../../assets/finance-home-icon.svg" alt="" />
                <span>购买充值</span>
            </div>
            <div v-else class="item" @click="jumpPage('/finance/deduction')">
                <img src="../../assets/finance-home-icon.svg" alt="" />
                <span>扣费记录</span>
            </div>
            <div class="item last" @click="jumpPage('/account/info')">
                <img src="../../assets/account-home-icon.svg" alt="" />
                <span>账号设置</span>
            </div>
        </div>
        <div class="liveHome">
            <div class="titleBox">
                <span>直播频道（共{{ totalChannelCount }}）</span>
                <button class="moreBtn" @click="jumpPage('/live/list')">更多 ></button>
            </div>
            <div class="videoBox">
                <template v-for="(item, index) in channelList">
                    <div class="listItem" :key="index">
                        <vue-loaders name="line-scale" class="playing" color="#67C23A" v-if="item.liveStatus === 'LIVING'"></vue-loaders>
                        <div class="listImgIcon">
                            <img :src="item.poster" alt="" />
                        </div>
                        <a href="javascipt:;" class="courseName">{{ item.title }}</a>
                        <div class="timeWrap">
                            <div class="time">
                                <span>时间：</span>
                                <span>{{ item.time }}</span>
                            </div>
                            <div class="">
                                <el-tag type="warning" size="small" v-if="(item.status & 2) !== 0 "><i class="el-icon-lock"></i>锁定</el-tag>
                                <el-tag type="danger" size="small" v-if="(item.status & (1 << 10)) !== 0"><i class="el-icon-turn-off-microphone"></i>禁播</el-tag>
                            </div>
                        </div>
                        <div class="operateBox">
                            <div class="operateItem" @click="channelStream(item.channelId)">
                                <div class="imgIcon">
                                    <img src="../../assets/liveIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/liveIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">发起直播</a>
                            </div>
                            <div class="operateItem shareOperate" @click="channelShare(item.channelId)">
                                <div class="imgIcon">
                                    <img src="../../assets/shareIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/shareIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">分享</a>
                            </div>
                            <div class="operateItem" @click="channelStatistics(item.channelId)">
                                <div class="imgIcon">
                                    <img src="../../assets/dataIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/dataIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">监控统计</a>
                            </div>
                            <div class="moreBox">
                                <div class="moreOperate">
                                    <div class="moreOperateMain">
                                        <div class="moreItem editItem" @click="editChannel(item.channelId)">
                                            <span class="icon"></span>编辑
                                        </div>
                                        <div class="moreItem demandItem" @click="channelRecords(item.channelId)">
                                            <span class="icon"></span>录播
                                        </div>
                                        <el-popconfirm title="确定要锁定频道吗？" @confirm="lockChannel(item)" v-if="(item.status & 2) === 0">
                                            <div class="moreItem lockItem" slot="reference">
                                                <span class="icon" ></span>锁定
                                            </div>
                                        </el-popconfirm>
                                        <div class="moreItem lockItem" @click="unlockChannel(item)" v-if="(item.status & 2) !== 0">
                                            <span class="icon" ></span>解锁
                                        </div>
                                        <el-popconfirm title="确定要删除频道吗？" @confirm="removeChannel(item)">
                                            <div class="moreItem deleteItem" slot="reference">
                                                <span class="icon"></span>删除
                                            </div>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="liveHome">
            <div class="titleBox">
                <span>视频文件（共{{ totalVodCount }}）</span>
                <button class="moreBtn" @click="jumpPage('/onDemand/list')">更多 ></button>
            </div>
            <div class="videoBox">
                <template v-for="(item, index) in vodList">
                    <div class="listItem" :key="index">
                        <div class="listImgIcon">
                            <img :src="item.poster" alt="" />
                        </div>
                        <a href="javascipt:;" class="courseName">{{ item.title }}</a>
                        <div class="timeWrap">
                            <div class="time">
                                <span>时间：</span>
                                <span>{{ item.time }}</span>
                            </div>
                        </div>
                        <div class="operateBox">
                            <div class="operateItem" @click="jumpVodPage('/onDemand/file', item.vodId)">
                                <div class="imgIcon">
                                    <img src="../../assets/liveIcon.svg" class="normal" alt=""/>
                                    <img src="../../assets/liveIcon-blue.svg" class="hover" alt=""/>
                                </div>
                                <a href="javascript:;">文件管理</a>
                            </div>
                            <div class="operateItem shareOperate" @click="jumpVodPage('/onDemand/share',item.vodId)">
                                <div class="imgIcon">
                                    <img src="../../assets/shareIcon.svg" class="normal" alt="" />
                                    <img src="../../assets/shareIcon-blue.svg" class="hover" alt="" />
                                </div>
                                <a href="javascript:;">分享</a>
                            </div>
                            <div class="operateItem" @click="jumpVodPage('/onDemand/statistics',item.vodId)">
                                <div class="imgIcon">
                                    <img src="../../assets/dataIcon.svg" class="normal" alt="" />
                                    <img src="../../assets/dataIcon-blue.svg" class="hover" alt="" />
                                </div>
                                <a href="javascript:;">访问统计</a>
                            </div>
                            <div class="moreBox">
                                <div class="moreOperate">
                                    <div class="moreOperateMain">
                                        <div class="moreItem editItem" @click="vodEdit(item.vodId)">
                                            <span class="icon"></span>编辑
                                        </div>
                                        <div class="moreItem lockItem" v-if="item.status<4" @click="vodLock(item)">
                                            <span class="icon"></span>锁定
                                        </div>
                                        <div class="moreItem lockItem" v-if="item.status>=4" @click="vodLock(item)">
                                            <span class="icon"></span>解锁
                                        </div>
                                        <el-popconfirm title="确定要删除视频吗？" @confirm="removeVod(item)">
                                            <div class="moreItem deleteItem" slot="reference">
                                                <span class="icon"></span>删除
                                            </div>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div class="right">
        <div class="app">
            <div class="imgWrap">
                <img src="../../assets/sliderBanner5.png" alt="">
            </div>
            <div class="title"><a href="javascript:;">Quicklive直播客户端</a></div>
            <div class="text">
                强大稳定的直播工具，支持插播视频、桌面共享等功能。
            </div>
            <div class="downloadBtn">
                <!--<button>立即下载</button>-->
                <el-link href="/downloads/quicklive_1.0.10.9.zip" target="_blank" :underline="false">立即下载</el-link>
            </div>
        </div>
        <!--<div class="desc">
            <div class="imgWrap">
                <img src="../../assets/banner2.png" alt="">
            </div>
            <div class="title"><a href="javascript:;">Quicklive特色</a></div>
            <div class="text">
                强大稳定的直播工具，支持插播视频、桌面共享等功能。
            </div>
        </div>-->
    </div>
</div>
</template>

<script>
    import common from '../../common.vue';
    import moment from 'moment';
    const LOCK_ERROR_MAPPER = {
        "0": "成功",
        "-1": "登录已过期",
        "2": "访问被拒绝"
    };

    export default {
        name: "Home",
        data() {
            return {
                balance: {},
                totalChannelCount: 0,
                channelList: [],
                totalVodCount: 0,
                vodList: [],
                sponsor: {showRecharge: false},
                flowClass: 'number',
                spaceClass: 'number',
                durationClass: 'number'
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            vodEdit(id) {
                this.$router.push({path: '/onDemand/edit/' +id});
            },
            jumpVodPage(path, id) {
                if (id) {
                    this.$router.push(`${path}` + '/' + id);
                } else {
                    this.$router.push(`${path}`);
                }
            },
            vodLock(vod){
                let _this = this;
                if(vod.status === 9){
                    _this.$message({
                        message: '超管锁定用户无法操作',
                        type: 'error'
                    });
                }else{
                    let targetStatus = vod.status === 1? 4 : 1;
                    _this.$axios.post(common.LOCK_VOD_URL, this.$qs.stringify({ids:vod.vodId, status:targetStatus})).then(function (res) {
                        console.log(res);
                        _this.$message({
                            message: targetStatus === 4? '锁定成功': '解锁成功',
                            type: 'success'
                        });
                        vod.status = targetStatus;
                    });
                }
            },
            removeVod(vod){
                let _this = this;
                _this.$axios.post(common.DELETE_VOD_URL, this.$qs.stringify({vodId: vod.vodId}
                )).then(function (res) {
                    let r = res.data;
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                    _this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    let index = _this.getVodIndex(vod.vodId);
                    index >= 0 && _this.vodList.splice(index, 1);
                });
            },
            // 获取点播在列表中的索引
            getVodIndex(vodId){
                let index = -1;
                for(let i=0; i<this.vodList.length; i++){
                    if(this.vodList[i].vodId === vodId){
                        index = i;
                    }
                }
                return index;
            },
            /**
             * 根据缓存用户数据调整界面
             */
            getCache(){
                let s = localStorage.getItem('sponsor');
                if(s){
                    this.sponsor = JSON.parse(s);
                }
            },
            /**
             * 获取首页内容
             */
            getData(){
                let _this = this;

                _this.$axios.post(common._BASE_ + 'sponsor/getData').then(function (res) {
                    let r = res.data;
                    if(r.code === 0){
                        _this.formatBalance(r.balance);
                        _this.totalChannelCount = r.channelCount;
                        _this.formatChannels(r.channels);
                        _this.totalVodCount = r.vodCount;
                        _this.formatVod(r.vods);
                    }
                });
            },
            /**
             * 格式化频道数据
             * @param channels
             */
            formatChannels(channels){
                if(!channels){ return; }

                (channels || []).forEach(function(item){
                    item.time = moment(item.lastActive || item.createTime).format("YYYY-MM-DD HH:mm");
                });
                this.channelList = channels;
            },
            formatVod: function(vodList){
                let vods = vodList || [];
                (vods).forEach(function(item){
                    item.time = moment(item.lastActive || item.createTime).format("YYYY-MM-DD HH:mm");
                });
                this.vodList = vods;
            },
            // 获取频道在列表中的索引
            getChannelIndex(channelId){
                let index = -1;
                for(let i=0; i<this.channelList.length; i++){
                    if(this.channelList[i].channelId === channelId){
                        index = i;
                    }
                }
                return index;
            },
            /**
             * 格式化余额信息
             * @param balance 余额数据
             */
            formatBalance(balance){
                console.info(balance);

                this.balance = balance || {};
                // 流量
                if(balance.flow === -1){
                    this.balance.formatFlow = '无限';
                    this.balance.formatFlowUnit = '';
                }else{
                    let f = common.formatSize(balance.flowOwe > 0? balance.flowOwe: balance.flow);
                    this.balance.formatFlow = f[0];
                    this.balance.formatFlowUnit = f[1];
                    this.flowClass = balance.flowOwe > 0? 'number owe': 'number';
                }
                // 空间
                if(balance.totalSpace === -1){
                    this.balance.formatSpace = '无限';
                    this.balance.formatSpaceUnit = '';
                }else{
                    let s = balance.totalSpace - balance.space, fs = common.formatSize(s);
                    this.balance.formatSpace = fs[0];
                    this.balance.formatSpaceUnit = fs[1];
                    this.spaceClass = s < 0? 'number owe': 'number';
                }
                // 时长
                if (balance.duration === -1) {
                    this.balance.formatDuration = '无限';
                } else{
                    this.balance.formatDuration = common.seconds2duration(balance.durationOwe > 0 ? balance.durationOwe : balance.duration);
                    this.durationClass = balance.durationOwe > 0? 'number owe': 'number';
                }
            },
            editChannel(cid){
                this.$router.push({
                    path: '/live/edit',
                    name: 'LiveEdit',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            channelStream(cid){
                this.$router.push({
                    path: '/live/launch',
                    name: 'LiveLaunch',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            channelShare(cid){
                this.$router.push({
                    path: '/live/share',
                    name: 'ChannelShare',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            channelStatistics(cid){
                this.$router.push({
                    path: '/live/statistics',
                    name: 'Statistics',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            channelRecords(cid){
                this.$router.push({
                    path: '/live/history',
                    name: 'LiveHistory',
                    params: { cid: cid },
                    query: {cid: cid}
                });
            },
            // 删除频道
            removeChannel(channel){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/channel/remove', this.$qs.stringify({channelId: channel.channelId})).then(function (res) {
                    let r = res.data;

                    if (r.code === -1){
                        _this.$message({
                            message: "登录已过期，请重新登录",
                            type: 'warning',
                            duration: 1000,
                            onClose: () => {
                                window.location.href = common.LOGON_URL;
                            }
                        });
                    }else if(r.code === 0){
                        // 频道设置为删除状态，从列表中删除
                        let index = _this.getChannelIndex(channel.channelId);
                        index >= 0 && _this.channelList.splice(index, 1);
                    }
                });
            },
            // 锁定频道
            lockChannel(channel){
                this.setChannelStatus(channel, true);
            },
            // 解锁频道
            unlockChannel(channel){
                this.setChannelStatus(channel, false);
            },
            // 设置频道状态
            setChannelStatus(channel, lock){
                let _this = this, uri = common._BASE_ + (lock? 'channel/lockChannel': 'channel/unlockChannel');
                _this.$axios.post(uri,
                    this.$qs.stringify({channelId: channel.channelId})).then(function (res) {
                    let r = res.data;
                    if(r.code === 0){
                        let ch = _this.channelList.find(c => c.channelId === channel.channelId);
                        if(ch){
                            let s = ch.status;
                            ch.status = lock? (s | 2) : (s & (~2));
                        }
                    }else{
                        _this.$notify({
                            title: '错误',
                            message: LOCK_ERROR_MAPPER[r.code + ''],
                            type: 'error',
                            duration: 1000,
                            onClose: function(){
                                if(r.code < 0){ _this.$router.push('/login');}
                            }
                        });

                    }
                });
            }
        },
        mounted(){
            this.getCache();
            this.getData();
        }
    };
</script> 

<style lang="less">
.homePage {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .left {
        width: 960px;

        .headerBoxTitle:hover {
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        }

        .headerTitle {
            font-size: 16px;
            font-weight: bold;
            color: #221816;
        }

        .balance {
            display: flex;

            .item {
                margin-right: 227px;
            }

            .last {
                margin-right: 0;
            }

            .middle {
                margin-right: 174px;
            }

            .title {
                font-size: 14px;
                font-weight: 400;
                color: #7e868c;
            }

            .number {
                font-size: 34px;
                font-weight: bold;
                color: #221816;
                margin-top: 6px;
                font-family: DIN Alternate;

                span {
                    font-size: 14px;
                    font-weight: 400;
                    color: #221816;
                    margin-left: 15px;
                }
            }

            .owe{
                color: #F56C6C;
            }
            .owe:before{
                content: '透支';
                font-size: 12px;
                margin-right: 8px;
            }
        }

        .entryBox {
            display: flex;
            align-items: center;
            margin-top: 18px;

            .item {
                width: 220px;
                height: 126px;
                background: #ffffff;
                border: 1px solid #e8e8e8;
                margin-right: 28px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                font-weight: 400;
                color: #221816;
                cursor: pointer;

                span {
                    margin-top: 10px;
                }
            }

            .item:hover {
                box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
                color: #306ff6;
            }

            .last {
                margin-right: 0;
            }
        }

        .liveHome {
            height: 357px;
            padding: 30px 30px 20px;
            background: #fff;
            border: 1px solid #e8e8e8;
            margin-top: 18px;

            .titleBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                font-weight: bold;
                color: #221816;

                span {
                    font-size: 16px;
                    font-weight: bold;
                    color: #221816;
                }
            }

            .moreBtn {
                width: 80px;
                height: 30px;
                background: #ffffff;
                border: 1px solid #f5f6f7;
                border-radius: 4px;
                font-size: 12px;
                line-height: 21px;
                color: #33363f;
            }

            .moreBtn:hover {
                background: #306ff6;
                color: #fff;
                border: none;
            }

            .videoBox {
                margin-top: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                /*overflow: hidden;*/

                .listItem {
                    margin-right: 30px;
                    margin-bottom: 20px;
                    height: 268px;
                }

                .listItem .playing {
                    position: absolute;
                    width: 48px;
                    top: 50px;
                    left: 50%;
                    right: 0;
                    margin-left: -24px;
                    z-index: 2;
                }

                .listItem:nth-child(3n + 3) {
                    margin-right: 0;
                }

                .operateBox {
                    height: 38px;
                    display: flex;
                    align-items: center;
                    border-top: 1px solid #e8e8e8;
                    padding-left: 10px;
                    position: relative;

                    .operateItem {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        .imgIcon {
                            width: 12px;
                            height: 12px;
                            margin-right: 4px;
                            position: relative;

                            img {
                                position: absolute;
                                top: 0;
                                left: 0;
                            }

                            img.hover {
                                display: none;
                            }
                        }
                    }

                    .operateItem:hover {
                        .imgIcon {
                            img.normal {
                                display: none;
                            }

                            img.hover {
                                display: block;
                            }
                        }
                    }

                    .shareOperate {
                        margin: 0 18px;
                    }

                    .moreBox {
                        width: 33px;
                        height: 38px;
                        border-left: 1px solid #e8e8e8;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: url("../../assets/moreIcon.svg") no-repeat center center;
                        cursor: pointer;
                    }

                    .moreBox:hover {
                        background: #306ff6 url("../../assets/moreIcon-white.svg") no-repeat center center;

                        .moreOperate {
                            display: block;
                        }
                    }

                    .moreOperate {
                        width: 106px;
                        height: 160px;
                        position: absolute;
                        top: 0;
                        right: -106px;
                        display: none;
                        z-index: 99;

                        .moreOperateMain {
                            width: 100px;
                            height: 160px;
                            margin-left: 6px;
                            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
                            font-size: 12px;
                            line-height: 40px;
                        }

                        .moreItem {
                            width: 100px;
                            height: 40px;
                            display: flex;
                            align-items: center;
                            color: #55565f;
                            background: #fff;
                            cursor: pointer;

                            span.icon {
                                width: 14px;
                                height: 12px;
                                display: inline-block;
                                margin-right: 8px;
                                margin-left: 19px;
                            }
                        }

                        .moreItem:hover {
                            color: #221816;
                            background: #f5f6f7;
                        }

                        .moreItem.editItem span.icon {
                            background: url("../../assets/edit-gray.svg") center center no-repeat;
                        }

                        .moreItem.demandItem span.icon {
                            background: url("../../assets/demand-gray.svg") center center no-repeat;
                        }

                        .moreItem.lockItem span.icon {
                            background: url("../../assets/lock-gray.svg") center center no-repeat;
                        }

                        .moreItem.deleteItem span.icon {
                            background: url("../../assets/delete-gray.svg") center center no-repeat;
                        }

                        .moreItem.editItem:hover span.icon {
                            background: url("../../assets/edit-black.svg") center center no-repeat;
                        }

                        .moreItem.demandItem:hover span.icon {
                            background: url("../../assets/demand-black.svg") center center no-repeat;
                        }

                        .moreItem.lockItem:hover span.icon {
                            background: url("../../assets/lock-black.svg") center center no-repeat;
                        }

                        .moreItem.deleteItem:hover span.icon {
                            background: url("../../assets/delete-black.svg") center center no-repeat;
                        }
                    }
                }
            }
        }
    }

    .right {
        width: 240px;

        .downloadBtn {
            text-align: center;
            margin-top: 10px;

            span {
                width: 180px;
                height: 40px;
                background: #ffffff;
                border: 1px solid #c1c5c5;
                border-radius: 20px;
                font-size: 14px;
                line-height: 40px;
                color: #55565f;
            }

            span:hover {
                background: #306ff6;
                color: #fff;
                border: none;
            }
        }

        .title {
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #33363f;
            padding: 0 18px;
            margin: 6px 0;

            a {
                color: #55565f;
            }

            a:hover {
                color: #306ff6;
            }
        }

        .text {
            font-size: 12px;
            font-weight: 400;
            line-height: 21px;
            color: #7e868c;
            padding: 0 18px;
        }

        .app {
            background: #fff;
            padding-bottom: 18px;
            margin-bottom: 18px;
        }

        .desc {
            background: #fff;
            padding-bottom: 18px;
        }

        .imgWrap {
            width: 240px;
            // height: 158px;
            overflow: hidden;

            img {
                width: 100%;
                height: auto;
                transition: all 0.6s;
                -webkit-transition: all 0.6s;
            }
        }
        .imgWrap:hover{
            img {
                transform: scale(1.1);
                -webkit-transform: scale(1.1);
            }
        }
    }
}

.el-card__header {
    padding: 0;
    width: 100%;

    .clearfix {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 51px;
        padding: 0 29px;
        font-size: 16px;
        font-weight: bold;
        color: #221816;
    }

    .check {
        width: 80px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #c1c5c5;
        border-radius: 4px;
    }

    .check:hover {
        background: #306ff6;
        color: #fff;
        border: none;
    }

    .buy {
        width: 80px;
        height: 30px;
        background: #306ff6;
        border-radius: 4px;
        margin-left: 15px;
        color: #fff;
    }

    .buy:hover {
        background: #4aa3f8;
    }
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
    box-shadow: none;
}


</style>